import React from 'react';
import './Loading.css';

/**
 * Componente de carga reutilizable para toda la aplicación
 * @param {string} mensaje - Mensaje opcional a mostrar (default: "Cargando")
 * @param {boolean} fullScreen - Si debe ocupar toda la pantalla (default: true)
 * @param {boolean} inline - Spinner y texto en una fila, sin padding (para headers/menús)
 * @param {string} size - Tamaño del spinner: "sm", "md", "lg" (default: "md")
 */
const Loading = ({ mensaje = "Cargando", fullScreen = true, size = "md", inline = false }) => {
  let containerClass = fullScreen ? "loading-container-global" : "loading-state-global";
  if (!fullScreen && size === "sm") containerClass += " loading-state-sm";
  if (inline) containerClass = "loading-inline-global";
  const spinnerClass = `loading-spinner-global loading-spinner-${size}`;

  return (
    <div className={containerClass}>
      <div className={spinnerClass}></div>
      <p className="loading-message-global">
        {mensaje}
        <span className="loading-dots">
          <span className="dot dot-1">.</span>
          <span className="dot dot-2">.</span>
          <span className="dot dot-3">.</span>
        </span>
      </p>
    </div>
  );
};

export default Loading;
